import React from 'react';
import Chatbot from '../components/chatbot';

function ChatbotPage() {
  return (
    <div>
      <Chatbot />
    </div>
  );
}

export default ChatbotPage;